<template>
  <div id="companyIntro">
    <!-- 顶部导航 -->
    <header class="nav" :class="{ 'nav-solid': scrolled }">
      <div class="nav-inner">
        <router-link to="/" class="nav-logo">
          <img :src="require('../assets/logo.png')" class="logo-mark" alt="广州新水科技有限公司" />
          <span class="logo-text">广州新水科技有限公司</span>
        </router-link>
        <nav class="nav-links">
          <a href="#profile" @click.prevent="scrollTo('profile')">公司介绍</a>
          <a href="#products" @click.prevent="scrollTo('products')">产品类型</a>
          <a href="#projects" @click.prevent="scrollTo('projects')">项目介绍</a>
          <a href="#qualify" @click.prevent="scrollTo('qualify')">企业资质</a>
          <a href="#contact" @click.prevent="scrollTo('contact')">联系方式</a>
        </nav>
        <!-- <router-link to="/" class="nav-back">返回官网</router-link> -->
      </div>
    </header>

    <!-- Hero -->
    <section class="hero">
      <img src="../assets/bj.png" class="hero-img" alt="新水科技品牌主视觉" />
      <div class="hero-mask"></div>
      <div class="hero-content reveal-stagger">
        <div class="hero-kicker">XINSHUI TECHNOLOGY · 新水科技</div>
        <h1 class="hero-title">以数据之水<br />润泽智慧城市</h1>
        <p class="hero-sub">
          广州新水科技有限公司 · 定制化软件 / AI设计 / 小程序开发 / 工业物联 等服务
        </p>
        <div class="hero-actions">
          <a href="#projects" class="btn-primary" @click.prevent="scrollTo('projects')">查看项目</a>
          <a href="#contact" class="btn-ghost" @click.prevent="scrollTo('contact')">联系我们</a>
        </div>
      </div>
      <div class="hero-scroll">向下滚动</div>
    </section>

    <!-- 基本档案 -->
    <section id="profile" class="section section-profile">
      <div class="container split">
        <div class="split-text reveal-stagger">
          <div class="kicker">COMPANY PROFILE · 公司简介</div>
          <h2 class="h-1">关于新水科技</h2>
          <p class="lead">
            广州新水科技有限公司是一家国家高新技术企业，专注于AI识别技术、物联网集成开发、定制软件应用提供商及相关智能系统研发。企业研发涵盖各类AI识别技术、应用软件等，广泛应用于智慧农业、明厨亮灶、市场监管、工业制造、人员和资产管理等领域，为政企单位提供个性化的软件应用整体解决方案，一站式解决客户问题。
          </p>
          <ul class="profile-list">
            <li>
              <span class="pl-label">公司全称</span>
              <span class="pl-value">广州新水科技有限公司</span>
            </li>
            <li>
              <span class="pl-label">所属地区</span>
              <span class="pl-value">广东省 · 广州市</span>
            </li>
            <li>
              <span class="pl-label">业务方向</span>
              <span class="pl-value">定制化软件 / 小程序开发 / 工业物联 / 智慧监管 / 官网设计等服务</span>
            </li>
            <li>
              <span class="pl-label">产品形态</span>
              <span class="pl-value">企业官网 · 微信小程序 · 工业化软件 · 定制化软件 · 应用程序</span>
            </li>
            <li>
              <span class="pl-label">备案信息</span>
              <span class="pl-value">粤ICP备18089087号</span>
            </li>
          </ul>
        </div>
        <div class="split-media reveal">
          <img :src="profileImg" alt="新水科技公司形象" class="media-img" />
          <div class="media-stat">
            <div class="stat-num">4<span>+</span></div>
            <div class="stat-label">落地行业场景</div>
          </div>
        </div>
      </div>
    </section>

    <!-- 产品类型 -->
    <section id="products" class="section section-products">
      <div class="container">
        <div class="section-head reveal-stagger">
          <div class="kicker">PRODUCT TYPES · 产品类型</div>
          <h2 class="h-1">五种产品形态，覆盖全链路交付</h2>
          <p class="section-desc">
            从对外展示的企业官网，到深度集成的工业化软件，新水科技以统一的工程标准交付不同形态的产品。
          </p>
        </div>
        <div class="product-grid">
          <div v-for="(p, i) in products" :key="i" class="product-card" @click="goProjects(p.slug)"
            @mousemove="onCardTilt" @mouseleave="onCardReset">
            <div class="pc-media">
              <img :src="p.img" :alt="p.name" />
            </div>
            <div class="pc-body reveal" :style="{ transitionDelay: (i % 3) * 0.14 + 's' }">
              <div class="pc-index">0{{ i + 1 }}</div>
              <h3 class="h-3">{{ p.name }}</h3>
              <p class="pc-desc">{{ p.desc }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 项目介绍 -->
    <section id="projects" class="section section-projects">
      <div class="container">
        <div class="section-head reveal-stagger">
          <div class="kicker">PROJECTS · 项目介绍</div>
          <h2 class="h-1">代表性项目</h2>
          <p class="section-desc">
            以下项目真实落地于城市监管、海洋监测与产业物联场景，含系统简介与现场项目照。
          </p>
        </div>

        <div v-for="(item, i) in projects" :key="i" class="project" :class="{ 'project-reverse': i % 2 === 1 }">
          <div class="project-gallery reveal">
            <div class="pg-main">
              <img :src="item.slides[0]" :alt="item.name" />
            </div>
            <div class="pg-thumbs" v-if="item.slides.length > 1">
              <div v-for="(s, idx) in item.slides.slice(1)" :key="idx" class="pg-thumb">
                <img :src="s" :alt="`${item.name} ${idx + 2}`" />
              </div>
            </div>
          </div>
          <div class="project-info reveal-stagger">
            <div class="project-no">PROJECT · 0{{ i + 1 }}</div>
            <h3 class="project-title">{{ item.name }}</h3>
            <div class="project-type">{{ item.type }}</div>
            <dl class="project-meta">
              <div class="pm-row">
                <dt>产品名称</dt>
                <dd>{{ item.name }}</dd>
              </div>
              <div class="pm-row">
                <dt>产品类型</dt>
                <dd>{{ item.type }}</dd>
              </div>
              <div class="pm-row">
                <dt>系统简介</dt>
                <dd>{{ item.desc }}</dd>
              </div>
              <div class="pm-row">
                <dt>展示案例</dt>
                <dd>{{ item.show }}</dd>
              </div>
            </dl>
          </div>
        </div>
      </div>
    </section>

    <section id="qualify" class="section section-qualify">
      <div class="container">
        <div class="section-head reveal-stagger">
          <div class="kicker">QUALIFICATIONS · 企业资质与荣誉</div>
          <h2 class="h-1">资质与软件著作权</h2>
          <p class="section-desc">企业资质证书与自主研发软件著作权登记证书。</p>
        </div>

        <div class="qualify-block reveal-stagger">
          <h3 class="qualify-sub">企业资质</h3>
          <div class="qualify-grid">
            <div v-for="(img, i) in ronyu" :key="'ry' + i" class="qualify-card">
              <img :src="img" :alt="`企业资质 ${i + 1}`" />
            </div>
          </div>
        </div>

        <div class="qualify-block reveal-stagger">
          <h3 class="qualify-sub">软件著作权</h3>
          <div class="qualify-grid">
            <div v-for="(img, i) in zzquan" :key="'zq' + i" class="qualify-card">
              <img :src="img" :alt="`软件著作权 ${i + 1}`" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 客户生态与成功案例 -->
    <section id="ecosystem" class="section section-ecosystem">
      <div class="container">
        <div class="section-head reveal-stagger">
          <div class="kicker">ECOSYSTEM · 客户生态与成功案例</div>
          <h2 class="h-1">与各行业客户共同成长</h2>
          <p class="section-desc">服务覆盖智慧监管、海洋监测、工业物联等多个领域，持续为客户创造价值。</p>
        </div>

        <!-- 统计数据 -->
        <div class="stats-grid reveal-stagger">
          <div v-for="(s, i) in stats" :key="i" class="stat-card" :style="{ transitionDelay: i * 0.08 + 's' }">
            <div class="stat-num">{{ s.num }}</div>
            <div class="stat-label">{{ s.label }}</div>
          </div>
        </div>
      </div>

      <!-- logo 自动滚动：两行反向滚动 -->
      <div class="logo-marquee reveal">
        <div class="logo-track logo-track-left">
          <div v-for="(img, i) in logos" :key="'la' + i" class="logo-item">
            <img :src="img" :alt="`客户 logo ${i + 1}`" />
          </div>
          <div v-for="(img, i) in logos" :key="'lb' + i" class="logo-item" aria-hidden="true">
            <img :src="img" :alt="`客户 logo ${i + 1}`" />
          </div>
        </div>
        <div class="logo-track logo-track-right">
          <div v-for="(img, i) in [...logos].reverse()" :key="'ra' + i" class="logo-item">
            <img :src="img" :alt="`客户 logo ${i + 1}`" />
          </div>
          <div v-for="(img, i) in [...logos].reverse()" :key="'rb' + i" class="logo-item" aria-hidden="true">
            <img :src="img" :alt="`客户 logo ${i + 1}`" />
          </div>
        </div>
      </div>
    </section>

    <!-- 联系方式 -->
    <section id="contact" class="section section-contact">
      <div class="container contact-wrap">
        <div class="contact-text reveal-stagger">
          <div class="kicker">CONTACT · 联系方式</div>
          <h2 class="h-display">让下一个项目，<br />从一次对话开始。</h2>
          <!-- <p class="lead">
            无论是智慧监管平台、海洋监测系统，还是工业物联定制软件，欢迎与新水科技团队交流。
          </p> -->
          <ul class="contact-list">
            <li>
              <span class="cl-label">公司全称</span>
              <span class="cl-value">广州新水科技有限公司</span>
            </li>
            <li>
              <span class="cl-label">商务邮箱</span>
              <span class="cl-value">dapeng_c@163.com</span>
            </li>
            <li>
              <span class="cl-label">所在地区</span>
              <span class="cl-value">广州市天河区黄埔大道西365号1407室 / 汕头市龙湖区高新电脑中心2期419</span>
            </li>
            <li>
              <span class="cl-label">备案信息</span>
              <span class="cl-value">粤ICP备18089087号</span>
            </li>
          </ul>
          <a href="mailto:dapeng_c@163.com" class="btn-primary contact-cta">发送商务邮件</a>
        </div>
        <div class="contact-card reveal">
          <img :src="contactImg" alt="联系新水科技" class="contact-card-img" />
          <div class="contact-card-body">
            <div class="ccb-title">新水科技 · 项目咨询</div>
            <div class="ccb-desc">
              告诉我们你的场景与目标，我们会回复可行的软件方案与落地路径。
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 页脚 -->
    <footer class="footer">
      <div class="container footer-inner">
        <div class="footer-brand">
          <img :src="require('../assets/logo.png')" class="logo-mark" alt="广州新水科技有限公司" />
          <span>广州新水科技有限公司</span>
        </div>
        <a href="https://beian.miit.gov.cn" class="footer-icp">粤ICP备18089087号 · Copyright © Guangdong gusher.tech Rights
          Reserved</a>

      </div>
    </footer>
  </div>
</template>

<script>
import { setSeo } from "@/utils/seo";

export default {
  name: "companyIntro",
  data() {
    const img = (prompt, size) =>
      "https://trae-api-cn.mchost.guru/api/ide/v1/text_to_image?prompt=" +
      encodeURIComponent(prompt) +
      "&image_size=" +
      size;
    return {
      scrolled: false,
      heroImg: '../assets/bj.png',
      profileImg: img(
        "[PURPOSE]: Company profile section image. [DESC]: Bright modern minimalist office space with large windows, soft daylight, clean white desks, a few people collaborating quietly, calm premium technology company atmosphere, lifestyle architectural photography, Airbnb aesthetic, no text",
        "landscape_4_3"
      ),
      contactImg: img(
        "[PURPOSE]: Contact section image. [DESC]: Minimalist still life of a clean desk with a notebook, a cup of tea and a smartphone showing a calm interface, soft warm natural light, neutral white tones, lifestyle photography, Airbnb aesthetic, no text",
        "portrait_4_3"
      ),
      products: [
        {
          name: "定制化软件",
          slug: "custom",
          desc: "按业务流程量身设计，从需求到交付全链路工程化。",
          img: img(
            "[PURPOSE]: Product category card image. [DESC]: Developer workspace with clean code on a monitor, minimal desk setup, warm soft light, lifestyle technology photography, Airbnb aesthetic, no text",
            "landscape_4_3"
          ),
        },
        {
          name: "企业官网",
          slug: "website",
          desc: "品牌展示与对外门户，兼顾形象与信息架构。",
          img: img(
            "[PURPOSE]: Product category card image. [DESC]: Minimalist modern corporate website displayed on a laptop in a bright airy office, soft daylight, clean white desk, lifestyle product photography, Airbnb aesthetic, no text",
            "landscape_4_3"
          ),
        },
        {
          name: "微信小程序",
          slug: "miniapp",
          desc: "轻量移动端应用，触达现场人员与公众用户。",
          img: img(
            "[PURPOSE]: Product category card image. [DESC]: Smartphone showing a clean minimal mobile app interface, held in hand, soft natural light, neutral background, lifestyle product photography, Airbnb aesthetic, no text",
            "landscape_4_3"
          ),
        },
        {
          name: "工业化软件",
          slug: "industrial",
          desc: "面向工业现场的监控、调度与设备集成系统。",
          img: img(
            "[PURPOSE]: Product category card image. [DESC]: Modern industrial control room with large data dashboards on screens, clean minimal aesthetic, soft cool lighting, documentary photography, Airbnb aesthetic, no text",
            "landscape_4_3"
          ),
        },

        {
          name: "应用程序",
          slug: "app",
          desc: "跨平台应用交付，覆盖桌面、移动与现场终端。",
          img: img(
            "[PURPOSE]: Product category card image. [DESC]: Modern smartphone and tablet showing clean colorful app interfaces on a white background, minimal elegant composition, soft shadows, product photography, Airbnb aesthetic, no text",
            "landscape_4_3"
          ),
        },
      ],
      projects: [
        {
          name: '"互联网+智慧监管"',
          type: "互联网+智慧监管系统",
          desc: '平台功能主要包括识别农贸市场“占道经营”、“违章停车”等事件',
          show: "通过市场内外现有监控进行视频转码、视频分析，识别事件通过派单管理方式下达各站点负责人。",
          slides: [
            require("../assets/jinpin/one.png"),
            require("../assets/jinpin/tow.png"),
            require("../assets/jinpin/thress.png"),
          ],
        },
        {
          name: '明厨亮灶监管平台',
          type: "智能化+智慧监管平台系统",
          desc: '识别商户"口罩识别"、"厨师帽识别"、"抽烟识别"、"老鼠识别"等',
          show: "通过商户配餐区/洗料区/熟食区监控进行视频转码与视频分析，识别事件通过派单管理方式下达各商户负责人",
          slides: [
            require("../assets/gaoxin/one.png"),
            require("../assets/gaoxin/tow.png"),
            require("../assets/gaoxin/thress.png"),
          ],
        },
        {
          name: "智慧海上监测平台",
          type: "应用软件+标签包装设备",
          desc: "物料分配-归纳-匹配-出库-包装",
          show: "通过手持设备的软件可定位查看行驶中的航道，实时检测巡查船只路径，记录巡查路径，现场发现问题时，监管人员记录拍照，系统将会智能记录坐标并上传至平台。",
          slides: [
            require("../assets/nanao/one.png"),
            require("../assets/nanao/tow.png"),
            require("../assets/nanao/thress.png"),
          ],
        },
        {
          name: "智慧路灯管理平台",
          type: "应用软件+标签包装设备",
          desc: "平台功能主要包括接入深圳城市部分道路路灯集成控制并进行检修管理。",
          show: "ABB",
          slides: [require("../assets/one.png")],
        },
      ],
      // 企业资质
      ronyu: [require("../assets/ronyu/1.png"), require("../assets/ronyu/2.png")],
      // 软件著作权
      zzquan: [
        require("../assets/zzquan/3.png"),
        require("../assets/zzquan/4.png"),
        require("../assets/zzquan/5.png"),
        require("../assets/zzquan/6.png"),
        require("../assets/zzquan/7.png"),
        require("../assets/zzquan/8.png"),
        require("../assets/zzquan/9.png"),
        require("../assets/zzquan/10.png"),
      ],
      // 客户 logo（自动滚动）
      logos: [
        require("../assets/logo/图片11.png"),
        require("../assets/logo/图片12.png"),
        require("../assets/logo/图片13.png"),
        require("../assets/logo/图片14.png"),
        require("../assets/logo/图片15.png"),
        require("../assets/logo/图片16.png"),
        require("../assets/logo/图片17.png"),
        require("../assets/logo/图片18.png"),
        require("../assets/logo/图片19.png"),
        require("../assets/logo/图片20.png"),
        require("../assets/logo/图片21.png"),
        require("../assets/logo/图片22.png"),
        require("../assets/logo/图片23.png"),
        require("../assets/logo/图片24.png"),
        require("../assets/logo/图片25.png"),
        require("../assets/logo/图片26.png"),
        require("../assets/logo/图片27.png"),
        require("../assets/logo/图片28.png"),
        require("../assets/logo/图片29.png"),
        require("../assets/logo/图片30.png"),
        require("../assets/logo/图片31.png"),
        require("../assets/logo/图片32.png"),
        require("../assets/logo/图片33.png"),
        require("../assets/logo/图片34.png"),
        require("../assets/logo/图片35.png"),
        require("../assets/logo/图片36.png"),
        require("../assets/logo/图片37.png"),
        require("../assets/logo/图片38.png"),
        require("../assets/logo/图片39.png"),
      ],
      // 统计数据
      stats: [
        { num: "500+", label: "交付项目" },
        { num: "200+", label: "合作客户" },
        { num: "30+", label: "行业覆盖" },
        { num: "10", label: "年技术沉淀" },
      ],
    };
  },
  mounted() {
    setSeo({
      title: "广州新水科技有限公司 · 定制化软件 / AI设计 / 小程序开发 / 工业物联 等服务",
      keywords:
        "新水科技公司介绍,智慧监管平台,海洋监测,工业物联网,广州新水科技,企业档案,项目案例",
      description:
        "广州新水科技公司介绍：专注智慧监管、海洋监测与工业物联网应用软件，提供企业官网、微信小程序、工业化软件与定制化软件，含公司档案、产品类型与代表项目。",
    });
    window.addEventListener("scroll", this.onScroll, { passive: true });
    this.$nextTick(this.initReveal);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.onScroll);
    if (this.revealObserver) {
      this.revealObserver.disconnect();
      this.revealObserver = null;
    }
  },
  methods: {
    onScroll() {
      this.scrolled = window.scrollY > 60;
    },
    initReveal() {
      const root = this.$el || document.getElementById("companyIntro");
      if (!root) return;
      const els = root.querySelectorAll(".reveal, .reveal-stagger");
      if (!els.length) return;
      if (!("IntersectionObserver" in window)) {
        els.forEach((el) => el.classList.add("is-visible"));
        return;
      }
      this.revealObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add("is-visible");
              this.revealObserver.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.15, rootMargin: "0px 0px -10% 0px" }
      );
      els.forEach((el) => this.revealObserver.observe(el));
    },
    scrollTo(id) {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    },
    onCardTilt(e) {
      const card = e.currentTarget;
      const rect = card.getBoundingClientRect();
      const rx = (0.5 - (e.clientY - rect.top) / rect.height) * 6;
      const ry = ((e.clientX - rect.left) / rect.width - 0.5) * 6;
      card.style.transform =
        "perspective(800px) rotateX(" +
        rx +
        "deg) rotateY(" +
        ry +
        "deg) translateY(-4px)";
    },
    onCardReset(e) {
      e.currentTarget.style.transform = "";
    },
    goProjects(slug) {
      this.$router.push("/projects/" + slug);
    },
  },
};
</script>

<style lang="less" scoped>
@rausch: #ff385c;
@rausch-dark: #e00b41;
@hof: #222222;
@foggy: #6a6a6a;
@grey-500: #c1c1c1;
@bebe: #ebebeb;
@deco: #dddddd;
@faint: #f7f7f7;
@white: #ffffff;
@radius-card: 12px;
@radius-btn: 9999px;
@radius-ghost: 8px;

#companyIntro {
  font-family: "DM Sans", "Inter", -apple-system, "PingFang SC",
    "Helvetica Neue", Arial, sans-serif;
  background: @white;
  color: @hof;
  -webkit-font-smoothing: antialiased;
  // overflow-x: hidden; 
}

.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  box-sizing: border-box;
}

.kicker {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: @rausch;
  margin-bottom: 14px;
}

.h-display {
  font-size: 48px;
  font-weight: 700;
  line-height: 1.12;
  letter-spacing: -0.02em;
  color: @hof;
  margin: 0 0 20px;
}

.h-1 {
  font-size: 30px;
  font-weight: 700;
  line-height: 1.25;
  letter-spacing: -0.01em;
  color: @hof;
  margin: 0 0 16px;
}

.h-3 {
  font-size: 20px;
  font-weight: 600;
  line-height: 1.2;
  color: @hof;
  margin: 0 0 8px;
}

.lead {
  font-size: 16px;
  font-weight: 400;
  line-height: 1.6;
  color: @foggy;
  margin: 0 0 24px;
}

.btn-primary {
  display: inline-block;
  background: @rausch;
  color: @white;
  border-radius: @radius-btn;
  padding: 13px 24px;
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
  transition: background 0.2s;

  &:hover {
    background: @rausch-dark;
  }
}

.btn-ghost {
  display: inline-block;
  background: rgba(255, 255, 255, 0.9);
  color: @hof;
  border: 1px solid @hof;
  border-radius: @radius-ghost;
  padding: 12px 22px;
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
  transition: background 0.2s;

  &:hover {
    background: @faint;
  }
}

/* ========== 导航 ========== */
.nav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  transition: background 0.3s, box-shadow 0.3s, border-color 0.3s;
  border-bottom: 1px solid transparent;

  .nav-inner {
    max-width: 1200px;
    margin: 0 auto;
    padding: 18px 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
  }

  .nav-logo {
    display: flex;
    align-items: center;
    gap: 10px;
    text-decoration: none;
    color: @white;
    font-weight: 700;
    font-size: 20px;
    letter-spacing: -0.01em;
    transition: color 0.3s;

    .logo-mark {
      width: 30px;
      height: 30px;
      object-fit: contain;
      display: inline-block;
      flex-shrink: 0;
    }
  }

  .nav-links {
    display: flex;
    gap: 26px;

    a {
      color: rgba(255, 255, 255, 0.92);
      text-decoration: none;
      font-size: 16px;
      font-weight: 500;
      transition: color 0.2s;

      &:hover {
        color: @white;
        opacity: 1;
      }
    }
  }

  .nav-back {
    color: @white;
    text-decoration: none;
    font-size: 13px;
    font-weight: 600;
    border: 1px solid rgba(255, 255, 255, 0.8);
    border-radius: @radius-ghost;
    padding: 8px 14px;
    transition: background 0.2s, color 0.2s;

    &:hover {
      background: @white;
      color: @hof;
    }
  }

  &.nav-solid {
    background: rgba(255, 255, 255, 0.92);
    backdrop-filter: saturate(180%) blur(12px);
    -webkit-backdrop-filter: saturate(180%) blur(12px);
    border-bottom: 1px solid @bebe;

    .nav-logo,
    .nav-back {
      color: @hof;
    }

    .nav-back {
      border-color: @hof;

      &:hover {
        background: @hof;
        color: @white;
      }
    }

    .nav-links a {
      color: @foggy;

      &:hover {
        color: @hof;
      }
    }
  }
}

/* ========== Hero ========== */
.hero {
  position: relative;
  height: 100vh;
  min-height: 620px;
  display: flex;
  align-items: center;
  overflow: hidden;

  .hero-img {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .hero-mask {
    position: absolute;
    inset: 0;
    background: linear-gradient(180deg,
        rgba(0, 0, 0, 0.35) 0%,
        rgba(0, 0, 0, 0.25) 45%,
        rgba(0, 0, 0, 0.55) 100%);
  }

  .hero-content {
    position: relative;
    z-index: 2;
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 24px;
    color: @white;
  }

  .hero-kicker {
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.16em;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.9);
    margin-bottom: 18px;
  }

  .hero-title {
    font-size: 64px;
    font-weight: 700;
    line-height: 1.08;
    letter-spacing: -0.02em;
    margin: 0 0 22px;
    color: @white;
  }

  .hero-sub {
    font-size: 18px;
    font-weight: 400;
    line-height: 1.5;
    color: rgba(255, 255, 255, 0.92);
    margin: 0 0 32px;
    max-width: 620px;
  }

  .hero-actions {
    display: flex;
    gap: 14px;
    flex-wrap: wrap;

    .btn-ghost {
      background: transparent;
      color: @white;
      border-color: rgba(255, 255, 255, 0.85);

      &:hover {
        background: rgba(255, 255, 255, 0.12);
      }
    }
  }

  .hero-scroll {
    position: absolute;
    bottom: 30px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 2;
    color: rgba(255, 255, 255, 0.85);
    font-size: 12px;
    letter-spacing: 0.1em;

    &::after {
      content: "";
      display: block;
      width: 1px;
      height: 26px;
      margin: 10px auto 0;
      background: rgba(255, 255, 255, 0.7);
    }
  }
}

/* ========== 通用 section ========== */
.section {
  padding: 96px 0;
}

.section-head {
  max-width: 680px;
  margin: 0 auto 56px;
  text-align: center;

  .section-desc {
    font-size: 16px;
    line-height: 1.6;
    color: @foggy;
    margin: 0;
  }
}

/* ========== 基本档案 ========== */
.section-profile {
  background: @white;

  .split {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 64px;
    align-items: center;
  }

  .split-text {
    .profile-list {
      list-style: none;
      margin: 0;
      padding: 0;
      border-top: 1px solid @bebe;

      li {
        display: flex;
        padding: 16px 0;
        border-bottom: 1px solid @bebe;
        align-items: flex-start;

        .pl-label {
          width: 110px;
          flex-shrink: 0;
          font-size: 13px;
          font-weight: 600;
          color: @foggy;
        }

        .pl-value {
          flex: 1;
          font-size: 14px;
          color: @hof;
          line-height: 1.5;
        }
      }
    }
  }

  .split-media {
    position: relative;

    .media-img {
      width: 100%;
      height: 460px;
      object-fit: cover;
      border-radius: @radius-card;
      display: block;
    }

    .media-stat {
      position: absolute;
      bottom: 20px;
      left: 20px;
      background: @white;
      border-radius: @radius-card;
      padding: 18px 22px;

      .stat-num {
        font-size: 36px;
        font-weight: 700;
        color: @hof;
        line-height: 1;

        span {
          color: @rausch;
        }
      }

      .stat-label {
        margin-top: 6px;
        font-size: 12px;
        color: @foggy;
        letter-spacing: 0.04em;
      }
    }
  }
}

/* ========== 产品类型 ========== */
.section-products {
  background: @faint;

  .product-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;
  }

  .product-card {
    position: relative;
    background: @white;
    border-radius: @radius-card;
    overflow: hidden;
    cursor: pointer;
    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1),
      box-shadow 0.3s ease;

    .pc-media {
      width: 100%;
      height: 180px;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
      }
    }

    .pc-body {
      padding: 22px 22px 26px;

      .pc-index {
        font-size: 12px;
        font-weight: 700;
        color: @rausch;
        letter-spacing: 0.08em;
        margin-bottom: 8px;
      }

      .pc-desc {
        font-size: 13px;
        color: @foggy;
        line-height: 1.55;
        margin: 0;
      }
    }
  }
}

/* ========== 项目介绍 ========== */
.section-projects {
  background: @white;

  .project {
    display: grid;
    grid-template-columns: 1.15fr 1fr;
    gap: 56px;
    align-items: center;
    padding: 56px 0;
    border-top: 1px solid @bebe;

    &:first-of-type {
      border-top: none;
    }

    &.project-reverse {
      .project-gallery {
        order: 2;
      }
    }
  }

  .project-gallery {
    .pg-main {
      width: 100%;
      height: 360px;
      border-radius: @radius-card;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
      }
    }

    .pg-thumbs {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 12px;
      margin-top: 12px;

      .pg-thumb {
        height: 130px;
        border-radius: @radius-card;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
        }
      }
    }
  }

  .project-info {
    .project-no {
      font-size: 12px;
      font-weight: 700;
      letter-spacing: 0.08em;
      color: @rausch;
      margin-bottom: 12px;
    }

    .project-title {
      font-size: 26px;
      font-weight: 700;
      line-height: 1.2;
      letter-spacing: -0.01em;
      color: @hof;
      margin: 0 0 10px;
    }

    .project-type {
      display: inline-block;
      font-size: 12px;
      font-weight: 600;
      color: @hof;
      background: @faint;
      border-radius: @radius-btn;
      padding: 6px 14px;
      margin-bottom: 22px;
    }

    .project-meta {
      margin: 0;

      .pm-row {
        padding: 14px 0;
        border-top: 1px solid @bebe;

        &:last-child {
          border-bottom: 1px solid @bebe;
        }

        dt {
          font-size: 12px;
          font-weight: 600;
          color: @foggy;
          margin-bottom: 6px;
        }

        dd {
          margin: 0;
          font-size: 14px;
          color: @hof;
          line-height: 1.55;
        }
      }
    }
  }
}

/* ========== 项目照集锦 ========== */
.section-gallery {
  background: @faint;

  .mosaic {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-auto-rows: 180px;
    gap: 14px;
  }

  .mosaic-cell {
    border-radius: @radius-card;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
      transition: transform 0.4s;
    }

    &:hover img {
      transform: scale(1.05);
    }
  }

  // 错落的网格：部分单元跨行/跨列，形成 mosaic 节奏
  .m-0 {
    grid-column: span 2;
    grid-row: span 2;
  }

  .m-3 {
    grid-row: span 2;
  }

  .m-5 {
    grid-column: span 2;
  }

  .m-7 {
    grid-row: span 2;
  }
}

/* ========== 企业资质与荣誉 ========== */
.section-qualify {
  background: @white;

  .qualify-block {
    margin-top: 40px;

    &:first-of-type {
      margin-top: 8px;
    }
  }

  .qualify-sub {
    font-size: 20px;
    font-weight: 700;
    color: @hof;
    margin-bottom: 22px;
    padding-left: 14px;
    border-left: 4px solid @rausch;
  }

  .qualify-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 18px;
  }

  .qualify-card {
    position: relative;
    border-radius: @radius-card;
    overflow: hidden;
    background: #fff;
    border: 1px solid rgba(17, 77, 217, 0.1);
    box-shadow: 0 6px 20px rgba(0, 20, 60, 0.06);
    aspect-ratio: 3 / 4;
    transition: transform 0.35s, box-shadow 0.35s;
    cursor: pointer;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      display: block;
      background: #f7f9fc;
    }

    &:hover {
      transform: translateY(-6px);
      box-shadow: 0 14px 36px rgba(0, 20, 60, 0.14);

      img {
        transform: scale(1.04);
        transition: transform 0.4s;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .section-qualify {
    .qualify-grid {
      grid-template-columns: repeat(2, 1fr);
      gap: 12px;
    }

    .qualify-sub {
      font-size: 17px;
      margin-bottom: 16px;
    }
  }
}

/* ========== 客户生态与成功案例 ========== */
.section-ecosystem {
  background: @faint;
  padding-bottom: 0;

  .stats-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 24px;
    margin-top: 48px;
  }

  .stat-card {
    position: relative;
    padding: 36px 20px;
    border-radius: @radius-card;
    background: linear-gradient(135deg, #0c2a66 0%, #114dd9 100%);
    text-align: center;
    overflow: hidden;
    box-shadow: 0 10px 30px rgba(17, 77, 217, 0.18);

    &::after {
      content: "";
      position: absolute;
      inset: 0;
      background: radial-gradient(circle at 80% 20%,
          rgba(255, 56, 92, 0.35),
          transparent 55%);
      pointer-events: none;
    }
  }

  .stat-num {
    position: relative;
    font-size: 52px;
    font-weight: 800;
    line-height: 1;
    letter-spacing: 1px;
    background: linear-gradient(180deg, #ffffff 0%, #aafcff 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .stat-label {
    position: relative;
    margin-top: 14px;
    font-size: 15px;
    color: rgba(255, 255, 255, 0.82);
    letter-spacing: 2px;
  }
}

/* logo 无限滚动 */
.logo-marquee {
  margin-top: 56px;
  padding: 24px 0 32px;
  overflow: hidden;
  -webkit-mask-image: linear-gradient(90deg,
      transparent,
      #000 12%,
      #000 88%,
      transparent);
  mask-image: linear-gradient(90deg,
      transparent,
      #000 12%,
      #000 88%,
      transparent);
}

.logo-track {
  display: flex;
  width: max-content;
  align-items: center;

  &.logo-track-left {
    animation: logoScrollLeft 40s linear infinite;
  }

  &.logo-track-right {
    margin-top: 16px;
    animation: logoScrollRight 50s linear infinite;
  }
}

.logo-item {
  flex: 0 0 auto;
  width: 180px;
  height: 80px;
  margin: 0 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border-radius: 10px;
  border: 1px solid @deco;
  box-shadow: 0 4px 14px rgba(0, 20, 60, 0.05);

  img {
    max-width: 84%;
    max-height: 70%;
    object-fit: contain;
    display: block;
  }
}

@keyframes logoScrollLeft {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(-50%);
  }
}

@keyframes logoScrollRight {
  0% {
    transform: translateX(-50%);
  }

  100% {
    transform: translateX(0);
  }
}

@media screen and (max-width: 768px) {
  .section-ecosystem {
    .stats-grid {
      grid-template-columns: repeat(2, 1fr);
      gap: 14px;
      margin-top: 28px;
    }

    .stat-card {
      padding: 24px 12px;
    }

    .stat-num {
      font-size: 38px;
    }

    .stat-label {
      font-size: 13px;
      letter-spacing: 1px;
    }

    .logo-item {
      width: 130px;
      height: 60px;
      margin: 0 10px;
    }
  }
}

/* ========== 联系方式 ========== */
.section-contact {
  background: @white;

  .contact-wrap {
    display: grid;
    grid-template-columns: 1.2fr 1fr;
    gap: 64px;
    align-items: center;
  }

  .contact-list {
    list-style: none;
    margin: 0 0 32px;
    padding: 0;
    border-top: 1px solid @bebe;

    li {
      display: flex;
      padding: 16px 0;
      border-bottom: 1px solid @bebe;
      align-items: center;

      .cl-label {
        width: 110px;
        flex-shrink: 0;
        font-size: 13px;
        font-weight: 600;
        color: @foggy;
      }

      .cl-value {
        flex: 1;
        font-size: 14px;
        color: @hof;
      }
    }
  }

  .contact-cta {
    margin-top: 4px;
  }

  .contact-card {
    border-radius: @radius-card;
    overflow: hidden;
    background: @faint;

    .contact-card-img {
      width: 100%;
      height: 340px;
      object-fit: cover;
      display: block;
    }

    .contact-card-body {
      padding: 26px;

      .ccb-title {
        font-size: 18px;
        font-weight: 700;
        color: @hof;
        margin-bottom: 8px;
      }

      .ccb-desc {
        font-size: 14px;
        color: @foggy;
        line-height: 1.55;
      }
    }
  }
}

/* ========== 页脚 ========== */
.footer {
  background: @faint;
  border-top: 1px solid @bebe;
  padding: 36px 0;

  .footer-inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 14px;
  }

  .footer-brand {
    display: flex;
    align-items: center;
    gap: 10px;
    font-weight: 700;
    color: @hof;

    .logo-mark {
      width: 26px;
      height: 26px;
      object-fit: contain;
      display: inline-block;
      flex-shrink: 0;
    }
  }

  .footer-icp {
    font-size: 12px;
    color: @foggy;
    text-decoration: none;

    &:hover {
      color: @hof;
    }
  }

  .footer-link {
    font-size: 13px;
    font-weight: 600;
    color: @rausch;
    text-decoration: none;

    &:hover {
      color: @rausch-dark;
    }
  }
}

/* ========== 响应式 ========== */
@media screen and (max-width: 1024px) {
  .hero .hero-title {
    font-size: 48px;
  }

  .section {
    padding: 72px 0;
  }

  .section-profile .split,
  .section-contact .contact-wrap {
    grid-template-columns: 1fr;
    gap: 40px;
  }

  .section-profile .split-media .media-img {
    height: 360px;
  }

  .section-products .product-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .section-projects .project {
    grid-template-columns: 1fr;
    gap: 28px;

    &.project-reverse .project-gallery {
      order: 0;
    }
  }

  .section-gallery .mosaic {
    grid-template-columns: repeat(3, 1fr);
  }

  .nav .nav-links {
    display: none;
  }
}

@media screen and (max-width: 768px) {
  .h-display {
    font-size: 34px;
  }

  .h-1 {
    font-size: 24px;
  }

  .hero {
    min-height: 560px;

    .hero-title {
      font-size: 36px;
    }

    .hero-sub {
      font-size: 15px;
    }

    .hero-actions {

      .btn-primary,
      .btn-ghost {
        padding: 11px 20px;
        font-size: 13px;
      }
    }
  }

  .section {
    padding: 56px 0;
  }

  .section-head {
    margin-bottom: 36px;
  }

  .section-products .product-grid {
    grid-template-columns: 1fr;
  }

  .section-profile .split-media .media-img {
    height: 280px;
  }

  .section-projects .project-gallery .pg-main {
    height: 240px;
  }

  .section-projects .project-gallery .pg-thumbs .pg-thumb {
    height: 90px;
  }

  .section-gallery .mosaic {
    grid-template-columns: repeat(2, 1fr);
    grid-auto-rows: 130px;
  }

  .section-gallery .m-0 {
    grid-column: span 2;
    grid-row: span 1;
  }

  .section-gallery .m-5 {
    grid-column: span 2;
  }

  .section-contact .contact-card .contact-card-img {
    height: 240px;
  }

  .footer .footer-inner {
    flex-direction: column;
    align-items: flex-start;
  }
}

/* ========== 滚动入场动画：从下往上过渡 ========== */
.reveal,
.reveal-stagger>* {
  opacity: 0;
  transform: translateY(40px);
  transition: opacity 1.3s cubic-bezier(0.22, 1, 0.36, 1),
    transform 1.3s cubic-bezier(0.22, 1, 0.36, 1),
    background-color 0.25s ease;
  will-change: opacity, transform;
}

.reveal.is-visible,
.reveal-stagger.is-visible>* {
  opacity: 1;
  transform: translateY(0);
}

.reveal-stagger.is-visible>*:nth-child(1) {
  transition-delay: 0s;
}

.reveal-stagger.is-visible>*:nth-child(2) {
  transition-delay: 0.14s;
}

.reveal-stagger.is-visible>*:nth-child(3) {
  transition-delay: 0.28s;
}

.reveal-stagger.is-visible>*:nth-child(4) {
  transition-delay: 0.42s;
}

.reveal-stagger.is-visible>*:nth-child(5) {
  transition-delay: 0.56s;
}

.reveal-stagger.is-visible>*:nth-child(6) {
  transition-delay: 0.7s;
}

.reveal-stagger.is-visible>*:nth-child(7) {
  transition-delay: 0.84s;
}

.reveal-stagger.is-visible>*:nth-child(8) {
  transition-delay: 0.98s;
}

@media (prefers-reduced-motion: reduce) {

  .reveal,
  .reveal-stagger>* {
    opacity: 1 !important;
    transform: none !important;
    transition: none !important;
  }
}
</style>

<style>
/* 产品卡 hover：3D 倾斜 + 雷达扫描边框光（参考 jetusesoft） */
@property --card-angle {
  syntax: "<angle>";
  inherits: false;
  initial-value: 0deg;
}

@keyframes cardBorderRotate {
  0% {
    --card-angle: 0deg;
  }

  100% {
    --card-angle: 360deg;
  }
}

#companyIntro .product-card::before {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: inherit;
  padding: 1.5px;
  background: conic-gradient(from var(--card-angle),
      transparent 62%,
      #ff385c 92%,
      transparent 100%);
  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask-composite: exclude;
  opacity: 0;
  transition: opacity 0.4s ease;
  pointer-events: none;
  z-index: 1;
  animation: cardBorderRotate 3s linear infinite;
}

#companyIntro .product-card:hover::before {
  opacity: 1;
}

#companyIntro .product-card:hover {
  box-shadow: 0 14px 36px rgba(0, 0, 0, 0.1);
}
</style>
